import React, { useState, useEffect, useContext } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { Button, ButtonGroup, FormCheck, Col, Row, Container, FormControl, Form } from 'react-bootstrap';
import { FormSection } from 'blaze-form';
import BlazeForm from '../form/Form';
import { modal } from '../modal/ModalEmitter';
import CustomerSelect from './CustomerSelect';
import CustomerSearch from './CustomerSearch';
// import CustomerUpdate from './CustomerUpdate';
import OfferSearch from './OfferSearch';
import OfferList from './OfferList';
import OfferPartList from './OfferPartList';
import PageContainer from '../PageContainer';
import Loyalty from './Loyalty';
import LoyaltyContext from './LoyaltyContext';

// const Title = ({ children }) => {
//   // eslint-disable-line
//   return (
//     <div id="page-title-container">
//       <div className="page-title-items">
//         <h4 id="page-title">{children}</h4>
//       </div>
//     </div>
//   );
// };

// part search 20.2820.69.0263.0Z CS10085

const localCustomers = [
  {
    name: 'customerNum',
    label: 'Customer',
    col: 12,
    validation: { page: 'PCU2', type: 'customer' },
  },
  {
    name: 'externalCustomerId',
    label: 'External Customer',
    col: 12,
    validation: {
      type: 'db',
      modelName: 'loyaltycustomer',
    },
  },
];

const personStyle = {
  padding: '5px',
  backgroundColor: '#eee',
};

const offerStyle = {
  padding: '5px',
  backgroundColor: 'var(--yellow-1)',
  marginLeft: '5px',
};

const Test = ({ user }) => {
  const [customer, setCustomer] = useState(null);
  const [redemptionId, setRedemptionId] = useState(null);
  const [offers, setOffers] = useState(null);
  const [parts, setParts] = useState({
    '20.2820.69.0263.0Z': false,
    CS10085: false,
  });

  const [customerNum, setCustomerNum] = useState('');

  const { fetchCustomerOffers, fetchBestOffers, voidRedemption, validateRedemption } = useContext(LoyaltyContext);

  const voidR = () => {
    voidRedemption(redemptionId);
  };

  const validateR = () => {
    validateRedemption(redemptionId);
  };

  const getSelectedParts = () => {
    const selected = Object.keys(parts).filter(k => parts[k] === true);
    return selected.length ? { partNumbers: selected.join(',') } : {};
  };

  const getOffers = () => {
    fetchCustomerOffers(customer.externalCustomerId, getSelectedParts()).then(response => {
      setOffers(response.data.TotalResults);
    });
  };

  const selectCustomer = customer => {
    setCustomer(customer);
    modal.closeAll();
  };

  const openCreate = onCreate => {
    modal.open('loyaltyCustomerUpdate', { onCreate });
  };

  const openSelectCustomer = () => {
    // modal.open('loyaltyCustomerSearch', { selectCustomer });

    const onCreate = response => {
      selectCustomer(response.data);
    };

    modal.open('loyaltyselect', {
      hidePrint: true,
      headerClass: 'primary',
      title: 'Select Loyalty Customer',
      size: 'lg',
      footer: (
        <>
          <Button onClick={() => openCreate(onCreate)} variant="success" style={{ float: 'left' }}>
            Create Customer
          </Button>
          <Button onClick={() => modal.close()} variant="secondary">
            Cancel
          </Button>
        </>
      ),
      message: (
        <Loyalty>
          <CustomerSelect onSelect={selectCustomer} dealerCustomerNum={customerNum} />
        </Loyalty>
      ),
    });
  };

  const openEdit = customerId => {
    modal.open('loyaltyCustomerUpdate', { customerId });
  };

  const openOfferSearch = (customerId, params, onSelect) => {
    modal.open('loyaltyoffersearch', {
      hidePrint: true,
      hideFooter: true,
      message: (
        <Loyalty>
          <OfferSearch
            customerId={customerId}
            initialSearch={{ externalCustomerId: customerId, ...params }}
            onSelect={onSelect}
          />
        </Loyalty>
      ),
    });
  };

  const openOfferPartPicker = (params, initialOffersSelected = []) => {
    modal.open('loyaltyofferpartlist', {
      hidePrint: true,
      hideFooter: true,
      message: (
        <Loyalty>
          <OfferPartList initialSearch={params} initialOffersSelected={initialOffersSelected} onSelect={console.log} />
        </Loyalty>
      ),
    });
  };

  useEffect(() => {
    if (customer) {
      setOffers(null);
      getOffers();
    }
  }, [customer]);

  useEffect(() => {
    if (customer) {
      setOffers(null);
      getOffers();
    }
  }, [parts]);

  if (!user || user.username !== 'dsisupport') {
    return null;
  }

  return (
    <PageContainer>
      <Loyalty>
        <Container>
          <Row>
            <Col md={6} lg={6} sm={12}>
              <FormSection title="Customer Selection">
                {!customer && (
                  <Form.Row>
                    <Col>
                      <FormControl
                        type="text"
                        onChange={e => setCustomerNum(e.target.value)}
                        placeholder="Customer Num (1710)"
                      />
                    </Col>

                    <Col>
                      <Button onClick={openSelectCustomer} variant="secondary">
                        Select Customer
                      </Button>
                    </Col>
                  </Form.Row>
                )}
                {customer && (
                  <>
                    <span style={personStyle}>
                      <a href="#" onClick={() => openEdit(customer.externalCustomerId)}>
                        {customer.firstName} {customer.lastName} ({customer.externalCustomerId})
                      </a>
                      <i className="fas fa-times" style={{ marginLeft: '5px' }} onClick={() => setCustomer(null)} />
                    </span>
                    {offers !== null && (
                      <span
                        style={offerStyle}
                        onClick={() => openOfferSearch(customer.externalCustomerId, getSelectedParts())}
                      >
                        Found <strong>{offers}</strong> Offers for {customer.firstName}{' '}
                        <i style={{ marginLeft: '5px' }} className="far fa-window-maximize" />
                      </span>
                    )}
                    {Object.keys(parts).map(k => {
                      return (
                        <FormCheck
                          key={k}
                          onClick={e => {
                            e.stopPropagation();
                            setParts({ ...parts, [k]: !parts[k] });
                          }}
                          checked={parts.k}
                          label={k}
                        />
                      );
                    })}
                  </>
                )}
              </FormSection>
            </Col>
          </Row>
        </Container>

        <Container>
          <Row>
            <Col md={12} lg={12} sm={12}>
              <FormSection title="Modal Test">
                <div className="mb-2">
                  <ButtonGroup>
                    <Button
                      id="customer-search"
                      variant="primary"
                      onClick={() => {
                        modal.open('loyaltyCustomerSearch');
                      }}
                    >
                      Customer Search
                    </Button>
                    <Button
                      onClick={() => {
                        modal.open('loyaltyCustomerSearch', { initialSearch: { firstName: 'Mark' } });
                      }}
                    >
                      With Initial
                    </Button>
                    <Button id="customer-create" variant="success" onClick={() => openCreate()}>
                      Customer Create
                    </Button>
                  </ButtonGroup>
                </div>
                <div className="mb-2">
                  <ButtonGroup>
                    <Button variant="primary" onClick={() => openOfferSearch()}>
                      Offer Search
                    </Button>
                    <Button onClick={() => openOfferSearch(976966)} variant="secondary">
                      With Customer
                    </Button>
                    <Button
                      onClick={() =>
                        openOfferSearch('', { partNumbers: '5296,C81-6022,C81-1013,02-01846,JA11100,E006-185' })
                      }
                    >
                      With Parts
                    </Button>
                    <Button
                      onClick={() => {
                        openOfferSearch(
                          976966,
                          {
                            partNumbers: 'CS10085,20.2820.69.0263.0Z',
                          },
                          redemptions => {
                            const things = redemptions.map(r => <div key={r.OfferUniqueId}>{r.OfferUniqueId}</div>);
                            modal.info({ title: 'Got These', message: <div>{things}</div> });
                          }
                        );
                      }}
                    >
                      With onSelect
                    </Button>

                    <Button
                      variant="primary"
                      onClick={() =>
                        // eslint-disable-next-line
                        openOfferPartPicker({
                          partNumbers: 'AC1001C,P54-1283-300,R010300,995543H0R,P27-6158-002EXCH,R008839',
                        })
                      }
                    >
                      OfferPartPicker
                    </Button>
                    <Button
                      onClick={() =>
                        // eslint-disable-next-line
                        openOfferPartPicker(
                          {
                            partNumbers: '5296,C81-6022,C81-1013,02-01846,JA11100,E006-185,309701-34,P54-1283-300',
                          },
                          [
                            '0e3b0b47-7f37-43e2-abe2-2a5eb38a9877:E006-185',
                            '61469615-08fd-4d49-8c8b-566ff75d07db:C81-1013',
                          ]
                        )
                      }
                    >
                      WithInitial
                    </Button>
                    <Button
                      variant="primary"
                      onClick={() =>
                        // eslint-disable-next-line
                        fetchBestOffers('1029579', {
                          partNumbers: 'AC1001C,P54-1283-300,R010300,995543H0R,P27-6158-002EXCH,R008839',
                          offerType: ['M', 'N', 'Y', 'Z'],
                        })
                      }
                    >
                      BestOffers
                    </Button>
                  </ButtonGroup>
                </div>
                {/* <div className="mb-2">
                  <ButtonGroup>
                    <Button onClick={voidR} variant="secondary">
                      Void
                    </Button>
                    <Button onClick={validateR} variant="secondary">
                      Validate
                    </Button>
                  </ButtonGroup>
                </div> */}
              </FormSection>
            </Col>
          </Row>
        </Container>

        <Container>
          <Row>
            <Col md={6} lg={6} sm={12}>
              <FormSection title="Redemption Test" className="mb-4">
                <Form.Row>
                  <Col>
                    <FormControl
                      type="text"
                      onChange={e => setRedemptionId(e.target.value)}
                      placeholder="Redemption Id"
                    />
                  </Col>
                  <Col>
                    <ButtonGroup>
                      <Button onClick={voidR} disabled={!redemptionId} variant="secondary">
                        Void
                      </Button>
                      <Button onClick={validateR} disabled={!redemptionId} variant="secondary">
                        Validate
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Form.Row>
              </FormSection>

              <FormSection title="Offer Search">
                <OfferSearch />
              </FormSection>
            </Col>

            <Col md={6} sm={12}>
              <FormSection title="Customer Search" className="mb-4">
                <CustomerSearch />
              </FormSection>

              <FormSection title="Local Customer Test">
                <BlazeForm layout={localCustomers} />
              </FormSection>
            </Col>
          </Row>
        </Container>

        <Container>
          <Row>
            <Col md={12} sm={12}>
              <FormSection title="Offer List (Standalone)">
                <OfferList initialOffersSelected={['8d114366-69d5-49f9-b957-ceb030d07414']} />
              </FormSection>
            </Col>
          </Row>
        </Container>
      </Loyalty>
    </PageContainer>
  );
};

Test.propTypes = {
  user: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    user: state.app.user,
  };
}

export default connect(mapStateToProps)(props => {
  return (
    <Loyalty>
      <Test {...props} />
    </Loyalty>
  );
});
